/* eslint-disable react-hooks/exhaustive-deps */
import { get } from "lodash";
import { each, isEmpty, sum, sortBy } from "lodash-es";
import React, { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2"
import { getStatisticsInvoice } from "../../apis/finances/statistics";
import { convertHexToRGBA, getColor } from "../../utils/color";
import { getDay, getYearRange } from "../../utils/date";
import { comma } from "../../utils/number";
import { CardHeader, CardUnit, Row, Col } from "../ContentLayout";
import DataComponent from "../DataComponent";
import Line from "../Line";
import RankList from "../List/RankList";
import Loading from "../Loading";
import NoData from "../NoData/NoData";
import Select from "../Select";

const getChartColors = (color) => {
  return [
    {
      backgorund: color,
      labelColor: "#ffffff",
    },
    {
      backgorund: convertHexToRGBA(color, 80),
      labelColor: "#ffffff",
    },
    {
      backgorund: convertHexToRGBA(color, 60),
      labelColor: "#ffffff",
    },
    {
      backgorund: convertHexToRGBA(color, 40),
      labelColor: color,
    },
    {
      backgorund: convertHexToRGBA(color, 20),
      labelColor: color,
    },
    {
      backgorund: getColor("color-gray-0"),
      labelColor: getColor("color-gray-5"),
    },
  ]
}

const PurchaseSalesPieChartItem = ({
  type,
  params = {},
  color,
}) => {
  const [colors] = useState(getChartColors(color));
  const [list, setList] = useState(null);
  const [data, setData] = useState(null);
  const [options, setOptions] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    submit(params)
  }, [params])

  const submit = (_params = {}) => {
    const { startAt, endAt, groupBy } = _params
    setIsLoading(true)
    getStatisticsInvoice({
      groupBy,
      range: {
        writeDate: {
          from: startAt,
          to: endAt
        }
      }
    })
      .then((response) => {
        const datas = []

        const invoices = response.data.data.filter((data) => data.supByrType === type)
        each(invoices, (data) => {
          const target = datas.find(d => d.label === get(data, 'client.name'))
          if (target) {
            target.data += data.totalAmt || 0
          } else {
            datas.push({
              label: get(data, 'client.name'),
              data: data.totalAmt
            })
          }
        })

        // debugger
        const _data = sortBy(datas, ['data']).reverse().slice(0, 5)

        setIsLoading(false)
        setList([..._data])
        setData({
          labels: _data.map(d => d.label),
          datasets: [{
            data: _data.map(d => d.data),
            backgroundColor: colors.map(c => c.backgorund),
            borderWidth: 0
          }]
        })
        setOptions({
          tooltips: {
            callbacks: {
              title: function (tooltipItem, data) {
                return tooltipItem[0].xLabel
              },
              label: function ({ datasetIndex, index, label: totalLabel }, data) {
                const target = data.datasets[datasetIndex]
                const label = data.labels[index]
                return `${label} : ${comma(target.data[index])}원`
              }
            }
          },
          legend: {
            display: false
          },
          layout: {
            padding: {
              left: 0,
              right: 10,
              top: 20,
              bottom: 0
            }
          },
          plugins: {
            datalabels: {
              color: colors.map(c => c.labelColor),
              formatter: (value) => {
                return comma(value / sum(_data.map(d => d.data)) * 100, 2) + '%'
              },
            },
          },
        })
      })
  }

  return <Row className="purchase-sales-pie">

    {isLoading ?
      <Loading color={color} /> :
      isEmpty(list) ? <NoData /> :
        <>
          <Col lg={5}>
            {data &&
              <Pie
                data={data}
                options={options}
                height={300}
              />
            }
          </Col>
          <Col lg={7}>
            <RankList
              color={color}
              list={list}
            ></RankList>

          </Col>
        </>
    }
  </Row>
}

const PurchaseSalesPieChart = ({ isYearRange }) => {
  const [tabList, setTabList] = useState([])
  const [tab, setTab] = useState(null)
  const [selectedYear, setSelectedYear] = useState(`${new Date().getFullYear()}`)
  const [params, setParams] = useState({
    groupBy: isYearRange ? "month" : "date",
    startAt: isYearRange ? `${new Date().getFullYear()}-01-01` : getDay(30),
    endAt: isYearRange ? `${new Date().getFullYear()}-12-31` : getDay(),
  })

  useEffect(() => {
    if (!isEmpty(tabList)) {
      setTab(tabList[0])
    }
  }, [tabList])

  useEffect(() => {
    setTabList([
      {
        id: 'sales',
        label: <>매출 <span className="color-red-80">TOP 5</span></>,
        Elem: <PurchaseSalesPieChartItem
          type="sales"
          color={getColor("color-red-100")}
          params={params}
        />,
      },
      {
        id: 'purchase',
        label: <>매입 <span className="color-green-100">TOP 5</span></>,
        Elem: <PurchaseSalesPieChartItem
          type="purchase"
          color={getColor("color-green-100")}
          params={params}
        />,
      }
    ])
  }, [params])

  const handleOnChangeYear = (e) => {
    const { value } = e.target
    setSelectedYear(value)
    setParams({
      ...params,
      startAt: `${value}-01-01`,
      endAt: `${value}-12-31`,
    })
  }

  return <div className="purchase-sales-pie-chart">
    {tab &&
      <>
        <CardHeader className="border-bottom-none">
          <div className="tab-list">
            {
              tabList.map((_tab, index) => (
                <React.Fragment key={index}>
                  {index > 0 &&
                    <Line
                      isVertical={true}
                      height={16}
                    />
                  }
                  <DataComponent
                    field={{
                      type: "button",
                      color: "text",
                      className: tab.id === _tab.id ? '' : 'inactiveed',
                      action: () => { setTab(_tab) },
                      label: _tab.label
                    }}
                  />
                </React.Fragment>
              ))
            }
          </div>
          <CardUnit>
            {isYearRange ?
              <>
                <Select
                  value={selectedYear}
                  onChange={handleOnChangeYear}
                  list={getYearRange()}></Select>
              </>
              : (
                <>
                  최근 1개월
                  <p className="sub-card-unit">{`(${getDay(30)} ~ ${getDay()})`}</p>
                </>
              )
            }

          </CardUnit>
        </CardHeader>

        {tabList.map(({ id, Elem }, idx) => (
          <React.Fragment key={idx}>
            {id === tab.id ? Elem : <></>}
          </React.Fragment>
        ))}

      </>
    }
  </div >
}

export default PurchaseSalesPieChart